module.exports = __webpack_public_path__ + "static/media/intro-cloud-small.1ec539d6.svg";